/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteRaceClass } from '../fn/race-class/delete-race-class';
import { DeleteRaceClass$Params } from '../fn/race-class/delete-race-class';
import { getRaceClassByRaceId } from '../fn/race-class/get-race-class-by-race-id';
import { GetRaceClassByRaceId$Params } from '../fn/race-class/get-race-class-by-race-id';
import { postRaceClasses } from '../fn/race-class/post-race-classes';
import { PostRaceClasses$Params } from '../fn/race-class/post-race-classes';
import { RaceClass } from '../models/race-class';
import { updateRaceClasses } from '../fn/race-class/update-race-classes';
import { UpdateRaceClasses$Params } from '../fn/race-class/update-race-classes';

@Injectable({ providedIn: 'root' })
export class RaceClassService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRaceClassByRaceId()` */
  static readonly GetRaceClassByRaceIdPath = '/races/{raceGuid}/classes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRaceClassByRaceId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRaceClassByRaceId$Response(params: GetRaceClassByRaceId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RaceClass>>> {
    const obs = getRaceClassByRaceId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRaceClassByRaceId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRaceClassByRaceId(params: GetRaceClassByRaceId$Params, context?: HttpContext): Observable<Array<RaceClass>> {
    const resp = this.getRaceClassByRaceId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<RaceClass>>): Array<RaceClass> => r.body)
    );
  }

  /** Path part for operation `deleteRaceClass()` */
  static readonly DeleteRaceClassPath = '/races/{raceGuid}/classes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRaceClass()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRaceClass$Response(params: DeleteRaceClass$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteRaceClass(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRaceClass$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRaceClass(params: DeleteRaceClass$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteRaceClass$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postRaceClasses()` */
  static readonly PostRaceClassesPath = '/classes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postRaceClasses()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postRaceClasses$Response(params: PostRaceClasses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RaceClass>>> {
    const obs = postRaceClasses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postRaceClasses$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postRaceClasses(params: PostRaceClasses$Params, context?: HttpContext): Observable<Array<RaceClass>> {
    const resp = this.postRaceClasses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<RaceClass>>): Array<RaceClass> => r.body)
    );
  }

  /** Path part for operation `updateRaceClasses()` */
  static readonly UpdateRaceClassesPath = '/races/{raceGuid}/classes/{raceClassGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRaceClasses()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRaceClasses$Response(params: UpdateRaceClasses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RaceClass>>> {
    const obs = updateRaceClasses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRaceClasses$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRaceClasses(params: UpdateRaceClasses$Params, context?: HttpContext): Observable<Array<RaceClass>> {
    const resp = this.updateRaceClasses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<RaceClass>>): Array<RaceClass> => r.body)
    );
  }

}
